const convertWeatherData = (data: string) => {
    if (data.length === 0) return '';
    // Parsear el JSON
    try {
        const json = JSON.parse(data);
        if (json === null || json === undefined) return 'No se encontró ningún dato';
        // Extraer datos clave del JSON
        const temperature = json.current.temperature_2m;
        const elevation = json.elevation;
        const dailyData = json.daily;

        // Construir las líneas del resultado
        let result = `TEMPERATURE: ${temperature.toFixed(1)} °C\n`;
        result += `ELEVATION: ${elevation} m\n`;
        result += `DAILY_WEATHER:\n`;

        // Iterar sobre los datos diarios y formatear cada entrada
        dailyData.time.forEach((date: string, index: number) => {
            const maxTemp = dailyData.temperature_2m_max[index].toFixed(1);
            const minTemp = dailyData.temperature_2m_min[index].toFixed(1);
            const windSpeed = dailyData.windspeed_10m_max[index].toFixed(1);
            const gustSpeed = dailyData.windgusts_10m_max[index].toFixed(1);

            result += `${date}: ${maxTemp} °C / ${minTemp} °C / ${windSpeed} km/h / ${gustSpeed} km/h\n`;
        });

        return result.trim();
    } catch (error) {
        console.error('Error al convertir datos de la API:', error);
        return 'Error al convertir datos de la API';
    }
};

export { convertWeatherData };
